import * as storage from "@atg-shared/storage";
import * as GameTypes from "@atg-horse-shared/game-types";
import type {QuickplayState} from "@atg-horse-shared/horse-state";
import {
    SELECT_QUICK_PLAY_TRACK,
    SELECT_QUICK_PLAY_RACE,
    SELECT_QUICK_PLAY_GAME_TYPE,
    SET_LIVE_BETS_VISITED,
    SET_LIVE_BETS_TOGGLED,
    SELECT_LIVE_TRACK,
} from "./quickplayActions";

import type {QuickplayAction} from "./quickplayActions";

const initialState = {
    liveBetsVisited: Boolean(storage.getItem("liveBetsVisited")),
    selectedTrack: null,
    selectedRaceId: null,
    selectedGameType: null,
    liveBetsToggled: null,
};

const quickplay = (
    state: QuickplayState = initialState,
    action: QuickplayAction,
): QuickplayState => {
    switch (action.type) {
        case SELECT_QUICK_PLAY_TRACK:
            return {
                ...state,
                selectedGameType: GameTypes.vinnare,
                selectedTrack: action.payload,
                selectedRaceId: null,
            };
        case SELECT_QUICK_PLAY_RACE:
            return {
                ...state,
                selectedGameType: action.payload.gameType,
                selectedRaceId: action.payload.raceId,
            };
        case SELECT_QUICK_PLAY_GAME_TYPE:
            return {
                ...state,
                selectedGameType: action.payload,
            };
        case SET_LIVE_BETS_VISITED:
            return {
                ...state,
                liveBetsVisited: action.payload,
            };
        case SET_LIVE_BETS_TOGGLED: {
            return {
                ...state,
                liveBetsToggled: action.payload,
            };
        }
        case SELECT_LIVE_TRACK: {
            return {
                ...state,
                selectedGameType: action.payload.currentGameType || GameTypes.vinnare,
                selectedRaceId: action.payload.selectedRaceId,
                selectedTrack: action.payload.selectedTrack,
            };
        }
        default:
            return state;
    }
};

export default quickplay;
